import React from 'react';
import {Helmet} from 'react-helmet';
import {notifyException} from 'utilities/analytics/bugsnag';
import {WithI18nProps, withI18n} from '@shopify/react-i18n';
import {TextContainer, DisplayText} from '@shopify/polaris';
import i18nArgs from './locales';
import {Routes} from '../../utilities';
import {AdapterLink} from 'components/polaris/react/adapter-link';

import styles from './ErrorBoundary.scss';

interface State {
  error: Error | null;
}

interface OwnProps {}

type CombinedProps = OwnProps & WithI18nProps;

class ErrorBoundary extends React.Component<CombinedProps, State> {
  state = {
    error: null,
  };

  componentDidCatch(error: Error, errorInfo: any) {
    this.setState({error});

    notifyException({
      errorName: 'ServicesMarketplacePublic:ErrorBoundary',
      error,
      meta: {errorInfo},
    });
  }

  render() {
    const {i18n, children} = this.props;
    const {error} = this.state;

    if (error) {
      const refreshLinkMarkup = (
        <a href={window.location.href}>
          {i18n.translate('ErrorBoundary.Page.refreshLink')}
        </a>
      );
      const supportLinkMarkup = (
        <AdapterLink external url={Routes.supportUrl()}>
          {i18n.translate('ErrorBoundary.Page.supportLink')}
        </AdapterLink>
      );

      return (
        <div className={styles.ErrorBoundary}>
          <Helmet>
            <title>{i18n.translate('ErrorBoundary.Meta.title')}</title>
          </Helmet>
          <TextContainer>
            <DisplayText size="large" element="h1">
              {i18n.translate('ErrorBoundary.Page.title')}
            </DisplayText>
            <DisplayText size="small" element="p">
              {i18n.translate('ErrorBoundary.Page.description')}
            </DisplayText>
            <DisplayText size="small" element="p">
              {i18n.translate('ErrorBoundary.Page.action', {
                refreshLink: refreshLinkMarkup,
                supportLink: supportLinkMarkup,
              })}
            </DisplayText>
          </TextContainer>
        </div>
      );
    }

    return children;
  }
}

export default withI18n(i18nArgs)(ErrorBoundary);
